// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"824":"c8b71458","844":"ce514a31"}[chunkId] + ".chunk.css";
};